import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    statusById: {}
}

const solicitacoesSlice = createSlice({
    name: 'solicitacoes',
    initialState,
    reducers: {
        atualizarStatus: (state, action) => {
            const { id, status } = action.payload;
            state.statusById[id] = status;
        },
    },
});

export const { atualizarStatus } = solicitacoesSlice.actions;

export default solicitacoesSlice.reducer;